import { render, staticRenderFns } from "./MoldRepair.vue?vue&type=template&id=184115bc&"
import script from "./MoldRepair.vue?vue&type=script&lang=js&"
export * from "./MoldRepair.vue?vue&type=script&lang=js&"
import style0 from "./MoldRepair.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports